export class FacturaOtroIngreso{
    constructor(
        public cliente: any = null,
        public cabecera: any = null,
        public detalles: any[] = [],
        public cuotas: any[] = [],
    ) {
    }
}